import { PaginationBox } from "components/Pagination/PaginationBox";
import { Wrapper, Content, Container } from "../style";
import SearchCategory from "../../SearchCategory";
import { useState } from "react";
import { POST_SWAP_LIST } from "constants/pathConstant";
import { Info, List } from "template/ListTemplate.style";
import chargeColumn from "./chargeByUserColumn.json";
import ChargeByUserDetail from "./ChargeByUserDetail";
import { CHARGE_XLSX_DOWNLOAD } from "constants/xlsxDownloadConstant";

// 회원검색 (검증 후 회원 정보 바로가기) :: 지갑정보 -> 충전 (http://localhost:3000/manage/user/:code)
const ChargeByUser = ({ acctCd }) => {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [resData, setResData] = useState([]);

  const API_ADDRESS = POST_SWAP_LIST;
  const XLSX_DOWNLOAD = CHARGE_XLSX_DOWNLOAD;

  const data = {
    id: "",
    useType: "",
    state: "90",
    txId: "",
    acctUserNm: "",
    acctCd,
    cellNumber: "",
    currentPage: page,
    pageSize: size,
  };

  return (
    <Wrapper>
      <SearchCategory
        API_ADDRESS={API_ADDRESS}
        data={data}
        setResData={setResData}
        setPage={setPage}
        setSize={setSize}
        page={page}
        size={size}
        resData={resData}
        XLSX_DOWNLOAD={XLSX_DOWNLOAD}
      />

      <Container>
        <Content>
          {chargeColumn.data.map((v, idx) => (
            <List.Row $ratio={v.ratio} key={idx}>
              {v.title}
            </List.Row>
          ))}
        </Content>

        <Info.Wrapper>
          {resData.map((v, idx) => (
            <ChargeByUserDetail data={v} key={idx} />
          ))}
        </Info.Wrapper>
      </Container>

      {resData.length !== 0 && (
        <PaginationBox
          totalItemsCount={resData[0]?.cnt}
          page={page}
          setPage={setPage}
          size={size}
        />
      )}
    </Wrapper>
  );
};

export default ChargeByUser;
